
import * as X2JS from 'x2js';

export class Tools {

    private static _x2jsInstance:X2JS;
  
    static get x2js():X2JS {
        if(!Tools._x2jsInstance){
            Tools._x2jsInstance = new X2JS();
        }
        return Tools._x2jsInstance;
    }

    static generateFormatedTimestamp():string{
        var cDate = new Date();
        var cTimestamp = cDate.toISOString();
        cTimestamp= cTimestamp.replace(/-/g, "");
        cTimestamp = cTimestamp.replace(/:/g, "");
        cTimestamp = [ cTimestamp.slice(0, 15), "Z" ].join("");
        return cTimestamp;
      }

    private static _accents:string = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    private static _accentsOut:string = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';

    static removeAccents(str):string{
        
        let _r = str.split('');
        var strLen = _r.length;
        var i, x;
        for (i = 0; i < strLen; i++) {
          if ((x = Tools._accents.indexOf(str[i])) != -1) {
            _r[i] = Tools._accentsOut[x];
          }
        }
        return _r.join('');
   }
  
  }